<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousClientView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center style="margin-left: 0.5rem !important"
            >Client Form</b-navbar-brand
          >
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter>
              <md-layout md-flex="30">
                <label for="clientType">Client Type</label>
                <model-list-select
                  :disabled="permissionStatus"
                  :list="clientTypeList"
                  v-model="clientDetail.clientType"
                  option-value="clientTypeVal"
                  option-text="clientTypeText"
                  placeholder="Select Type"
                ></model-list-select>

                <span class="error" v-if="!clientDetail.clientType">{{
                  clientTypeError
                }}</span>
              </md-layout>
             
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Client Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="clientName"
                    id="clientName"
                    v-model="clientDetail.clientName"
                    :disabled="
                      clientDetail.clientId != '' &&
                      this.$sessionsStorage.get('designation') != 'Admin'
                        ? true
                        : false
                    "
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.clientName">{{
                  clientError
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Contact Number</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    name="phoneKYC"
                    id="phoneKYC"
                    v-model="clientDetail.phoneKYC"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.phoneKYC">{{
                  phoneKYCError
                }}</span>
                <!-- <span class="error" v-else>{{ mobileValid }}</span> -->
                <!-- @keyup="mobileValidation" -->
              </md-layout>
            <!-- </md-layout>
            <md-layout md-gutter> -->
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Email Address</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="email"
                    id="email"
                    @keyup="isEmailValid"
                    v-model="clientDetail.email"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.email">{{ emailError }}</span>
                <span class="error" v-if="clientDetail.email">{{
                  errorEmailFormat
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Alternate Email</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="altMail"
                    id="altMail"
                    v-model="clientDetail.altMail"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>PAN No.(AAAAA1234A)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="panNO"
                    id="panNO"
                    v-model="clientDetail.panNO"
                    @keyup="PANErrorValid1()"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.panNO">{{ panNOError }}</span>
                <span class="error" v-else>{{ PANErrorValid }}</span>
              </md-layout>
            <!-- </md-layout>
            <md-layout md-gutter> -->
              <!-- <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>TAN No.(AAAA12345A)</label>
                  <b-form-input :formatter="capitalizeAll"
                    name="tanNO"
                    id="tanNO"
                    v-model="clientDetail.tanNO"
                    @keyup="TANErrorValid1()"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.tanNO">{{
                  tanNOError
                }}</span>
                <span class="error" v-else>{{ TANErrorValid }}</span>
              </md-layout> -->
              <!-- <md-layout md-flex="5"></md-layout> -->
               <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>IEC Number</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="clientName"
                    id="clientName"
                    v-model="clientDetail.IEC"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="companyType">Type of Company</label>

                  <model-list-select
                    :disabled="permissionStatus"
                    :list="companyTypeList"
                    v-model="clientDetail.companyType"
                    option-value="companyTypeVal"
                    option-text="companyTypeText"
                    placeholder="Select Company Type"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!clientDetail.companyType">{{
                  companyTypeError
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="30">
                <label for="State">State</label>
                <model-list-select
                  :isDisabled="permissionStatus"
                  :list="stateDetail"
                  v-model="clientDetail.state"
                  option-value="stateId"
                  option-text="stateName"
                  placeholder="Select State "
                ></model-list-select>

                <span class="error" v-if="!clientDetail.state">{{ stateError }}</span>
              </md-layout>
            <!-- </md-layout>
            <md-layout md-gutter> -->
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="companyType">Company Permitted</label>

                  <model-list-select
                    :disabled="permissionStatus"
                    :list="companyPermitList"
                    v-model="clientDetail.permitted"
                    option-value="permitVal"
                    option-text="permitText"
                    placeholder="Select Permit Type"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!clientDetail.permitted">{{
                  permittedError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>TAN No.(AAAA12345A)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="tanNO"
                    id="tanNO"
                    v-model="clientDetail.tanNO"
                    @keyup="TANErrorValid1()"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.tanNO">{{ tanNOError }}</span>
                <span class="error" v-else>{{ TANErrorValid }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="5" v-if="clientDetail.permitted != 'GSTUnregistered'">
                <md-layout md-flex="100">
                  <label>Code</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="StateCode"
                    id="StateCode"
                    v-model="clientDetail.stateCode"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="25" v-if="clientDetail.permitted != 'GSTUnregistered'">
                <md-layout md-flex="100">
                  <label>GSTN No.(AAAAA1234A1Z5)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="GSTN"
                    id="GSTN"
                    v-model="clientDetail.GSTN"
                    @keyup="GSTNErrorValid1()"
                    :disabled="
                      permissionStatus ? true : clientDetail.state == '' ? true : false
                    "
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.GSTN">{{ GSTNError }}</span>
                <span class="error" v-else>{{ GSTNErrorValid }}</span>
              </md-layout>
            <!-- </md-layout>

            <md-layout md-gutter> -->
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Corporate Address</label>
                  <b-form-textarea
                    :formatter="(value) => value.toUpperCase()"
                    name="corporateAddress"
                    id="corporateAddress"
                    v-model="clientDetail.corporateAddress"
                    :disabled="permissionStatus"
                  ></b-form-textarea>
                </md-layout>
                <span class="error" v-if="!clientDetail.corporateAddress">{{
                  corporateAddressError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Credit Days</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="creditDays"
                    id="creditDays"
                    type="number"
                    v-model="clientDetail.creditDays"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="gutr"> -->

            <!-- <md-layout md-flex="50" class="pl-2">
                <md-layout md-flex="100">
                  <label>Tan NO</label>
                  <b-form-input :formatter="capitalizeAll"
                    name="tanNo"
                    id="tanNo"
                    v-model="clientDetail.creditDays"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
              </md-layout> -->
            <!-- </md-layout> -->
            <md-layout md-gutter class="mt-2">
              <span>Segment :</span>
            </md-layout>
            <md-layout md-gutter>
              <md-layout
                v-for="(segmentNameArray, index) in showSegmentArray"
                :key="index"
                :md-flex="segmentNameArray.flex"
              >
                <md-checkbox
                  v-model="clientDetail.segment[index]"
                  class="md-primary"
                  :md-value="segmentNameArray.value"
                  :name="'segment' + (index + 1)"
                  :id="'segment' + (index + 1)"
                  :disabled="permissionStatus"
                  >{{ segmentNameArray.show }}</md-checkbox
                >
              </md-layout>
            </md-layout>

            <div class="mt-2">
              <md-layout md-gutter>
                <div>
                  <b-button id="show-btn" size="sm" variant="primary" @click="showModal"
                    >Add Client Factory</b-button
                  >
                  <span class="error" v-if="multiFactError != ''">{{
                    this.multiFactError
                  }}</span>
                  <b-modal ref="my-modal" hide-footer title="">
                    <div class="d-block text-center">
                      <h5>Client Factory Details !</h5>
                      <hr />

                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>

                        <span class="error">{{
                          this.viewAllFactory.length == 0 ? multiFactError : ""
                        }}</span>
                      </md-layout>
                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label
                              >Factory Title-Location]( e.g : Pridel Pvt Ltd-Delhi)</label
                            >
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="factoryTitle"
                              id="factoryTitle"
                              v-model="factoryModal.factoryTitle"
                              :disabled="permissionStatus"
                            ></b-form-input>
                            <span class="error" v-if="!factoryModal.factoryTitle">{{
                              factoryTitleError
                            }}</span>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>Address</label>
                            <b-form-textarea
                              :formatter="(value) => value.toUpperCase()"
                              name="factoryAddress1"
                              id="factoryAddress1"
                              v-model="factoryModal.factoryAddress1"
                              :disabled="permissionStatus"
                            ></b-form-textarea>
                            <span class="error" v-if="!factoryModal.factoryAddress1">{{
                              factoryAddress1Error
                            }}</span>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr">
                        <div class="mt-2">
                          <b-button
                            :disabled="factoryModal.factoryAddress1 == '' ? true : false"
                            class="pull-left ml-4"
                            size="sm"
                            variant="outline-info"
                            @click="fetchLatLog"
                            >Get Lat/Long</b-button
                          >
                        </div>
                      </md-layout>

                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Latitude</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              min="0"
                              id="latitude"
                              name="latitude"
                              v-model="factoryModal.latitude"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Longitude</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              min="0"
                              id="latitude"
                              name="latitude"
                              v-model="factoryModal.longitude"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>GSTIN No</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="GSTIN1"
                              id="GSTIN1"
                              v-model="factoryModal.GSTIN1"
                              :disabled="permissionStatus"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </div>
                    <b-button
                      class="mt-3"
                      block
                      variant="primary"
                      @click="addClient('', 'AddFactory')"
                      >{{ factoryModal.multiFactoryId == "" ? "Add " : "Update " }}
                      Factory
                    </b-button>
                    <b-button
                      class="mt-3"
                      variant="outline-danger"
                      block
                      @click="hideModal"
                      >Close
                    </b-button>
                  </b-modal>
                </div>
              </md-layout>

              <div class="gutr" v-if="viewAllFactory.length > 0">
                <table id="factoryDetails" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Factory Title</th>
                      <th>Factory Address</th>
                      <th>Factory GSTIN</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in viewAllFactory" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td
                        v-if="item.enableEdit == '1'"
                        @click="EditFactory(item)"
                        class="showMoreData"
                      >
                        {{ item.factoryTitle }}
                      </td>
                      <td v-else>{{ item.factoryTitle }}</td>
                      <td>{{ item.factoryAddress1 }}</td>

                      <td>{{ item.GSTIN1 }}</td>
                      <td>{{ item.latitude }}</td>
                      <td>{{ item.longitude }}</td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="deleteData(item.multiFactoryId)"
                        >
                          <md-icon>delete_sweep</md-icon>
                        </md-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h5 class="mt-3" v-if="contactPersonArry.length > 0">
              <b-badge variant="info">Contact Person</b-badge>
            </h5>
            <b-button
              class="mt-2"
              v-else
              id="show-btn"
              size="sm"
              variant="primary"
              @click="AddMoreContactP"
              >Add Contact Person</b-button
            >

            <div class="mt-3" v-if="contactPersonArry.length > 0">
              <table class="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>
                      SN<br />
                      <b-button
                        class="mt-2"
                        size="sm"
                        variant="outline-info"
                        @click="AddMoreContactP"
                        >Add More
                        <!-- @click="addQuotationFields" -->
                      </b-button>
                    </th>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Email</th>
                    <th>Dept</th>
                    <th>Designation</th>
                    <th></th>
                  </tr>
                  <tr v-for="(item, index) in contactPersonArry" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.name"
                      ></b-form-input>
                    </td>

                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.phone"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.email"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.dept"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.deg"
                      ></b-form-input>
                    </td>

                    <td>
                      <b-button
                        variant="outline-danger"
                        @click="removeCp(index)"
                        size="sm"
                        >Remove</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <md-layout md-flex="100">
                <label>Free Detention Period</label>
                <b-form-input :formatter="capitalizeAll"
                  type="number"
                  min="0"
                  name="detentionPeriod"
                  id="detentionPeriod"
                  v-model="clientDetail.detentionPeriod"
                  :disabled="permissionStatus"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!clientDetail.detentionPeriod">{{detentionPeriodError}}</span>
            </md-layout>
            </md-layout>-->
            <!-- <md-layout md-gutter class="mt-4">
              
              <md-layout md-flex="10">
                <b>Permitted :</b>
              </md-layout>

              <md-layout md-flex="15">
                <md-radio
                  id="permitted"
                  name="permitted1"
                  md-value="GSTRegistered"
                  v-model="clientDetail.permitted"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >GST Registered</md-radio
                >
              </md-layout>

              <md-layout md-flex="15">
                <md-radio
                  id="permitted2"
                  name="permitted2"
                  v-model="clientDetail.permitted"
                  md-value="GSTUnregistered"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >GST Unregistered</md-radio
                >
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="permitted3"
                  name="permitted3"
                  v-model="clientDetail.permitted"
                  md-value="SEZ"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >SEZ</md-radio
                >
              </md-layout>

              <md-layout md-flex="50"></md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <span class="error" v-if="!clientDetail.permitted">{{
                permittedError
              }}</span>
            </md-layout> -->

            <!-- <md-layout md-gutter class="mrgtop-3per">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <b>Contract :</b>
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="isContract1"
                  name="isContract1"
                  md-value="Yes"
                  v-model="clientDetail.isContract"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >Yes</md-radio
                >
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="isContract2"
                  name="isContract2"
                  v-model="clientDetail.isContract"
                  md-value="No"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >No</md-radio
                >
              </md-layout>

              <md-layout md-flex="30"></md-layout>
            </md-layout> -->

            <!-- <md-layout
              md-gutter
              class="mrgtop-3per"
              v-if="clientDetail.isContract == 'Yes'"
            >
              <md-layout md-flex="15"></md-layout>

              <md-layout md-flex="20">
                <md-radio
                  id="hireContract1"
                  name="hireContract1"
                  md-value="commercialContract"
                  v-model="clientDetail.hireContract"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >Commercial Contract</md-radio
                >
              </md-layout>

              <md-layout md-flex="15">
                <md-radio
                  id="hireContract2"
                  name="hireContract2"
                  v-model="clientDetail.hireContract"
                  md-value="hireContract"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >Hire Contract</md-radio
                >
              </md-layout>

              <md-layout md-flex="30"></md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="mrgtop-2per"
              v-if="
                clientDetail.hireContract == 'commercialContract' &&
                clientDetail.isContract == 'Yes'
              "
            >
              <md-layout md-flex="15"></md-layout>
              <md-layout md-flex="70">
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Rate Signed</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="rateSigned"
                      name="rateSigned"
                      v-model="clientDetail.rateSigned"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="10"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Rate of Diesel</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="rateDiesel"
                      name="rateDiesel"
                      v-model="clientDetail.rateDiesel"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="15"></md-layout>

                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Tolls</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="tolls"
                      name="tolls"
                      v-model="clientDetail.tolls"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="100" class="gutr">
                  <md-layout md-flex="100">
                    <label>Payment Terms</label>
                    <b-form-textarea :formatter="(value) => value.toUpperCase()"
                      id="paymentTerms"
                      name="paymentTerms"
                      v-model="clientDetail.paymentTerms"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="100" class="gutr">
                  <md-layout md-flex="100">
                    <label>Term of Contract</label>
                    <b-form-textarea :formatter="(value) => value.toUpperCase()"
                      id="contractTerm"
                      name="contractTerm"
                      v-model="clientDetail.contractTerm"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <span
                class="error"
                v-if="
                  !clientDetail.hireContract && clientDetail.isContract == 'Yes'
                "
                >{{ hireContractError }}</span
              >

              <span class="error" v-if="!clientDetail.isContract">{{
                isContractError
              }}</span>

              <span
                class="error"
                v-else-if="
                  !clientDetail.iscontractId && clientDetail.isContract == 'Yes'
                "
                >{{ isContractError1 }}</span
              >
            </md-layout>

            <md-layout
              md-gutter
              class="mrgtop-2per"
              v-if="
                clientDetail.hireContract == 'hireContract' &&
                clientDetail.isContract == 'Yes'
              "
            >
              <md-layout md-flex="15"></md-layout>

              <md-button
                class="md-raised md-primary md-button-color heght-1px"
                @click="openContractDialog('dialog2')"
                id="addButtonLoader1"
                :disabled="permissionStatus"
                >Add Contract</md-button
              >
              <md-spinner
                md-indeterminate
                id="loader1"
                style="display: none"
              ></md-spinner>
            </md-layout>

            <div
              class="box mrgtop-2per"
              v-if="
                contractTable.length > 0 && clientDetail.isContract == 'Yes'
              "
            >
              <div class="box-header">
                <h3 class="box-title">Contract details</h3>
              </div>
            
              <div class="box-body">
                <table
                  id="contracthireModel"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Contract No.</th>
                      <th>From Validity</th>
                      <th>To Validity</th>
                      <th>Contract Type</th>
                      <th>Allowed Kilometer</th>
                      <th>Monthly Rent</th>
                      <th>Overcharges</th>

                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in contractTable" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.contractSeries }}</td>
                      <td>{{ item.fromValidity | moment }}</td>
                      <td>{{ item.toValidity | moment }}</td>
                      <td>{{ item.contractType }}</td>
                      <td>{{ item.allowedKm }}</td>
                      <td>{{ item.monthlyRent }}</td>
                      <td>{{ item.overcharges }}</td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="viewContract(item.contractId)"
                        >
                          <md-icon>edit</md-icon>
                        </md-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            
            </div> -->

            <md-layout md-gutter class="mt-3">
              <md-layout md-flex="10">
                <b>KYC Done :</b>
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="isKYC1"
                  name="isKYC1"
                  @change="AddMoreDocs"
                  v-model="clientDetail.isKYC"
                  md-value="Yes"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >Yes</md-radio
                >
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="isKYC2"
                  name="isKYC2"
                  v-model="clientDetail.isKYC"
                  md-value="No"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >No</md-radio
                >
              </md-layout>
            </md-layout>
            <div
              class="mt-3"
              v-if="showDocSection.length > 0 || clientDetail.isKYC == 'Yes'"
            >
              <table class="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>SN.</th>
                    <th>Document Name</th>
                    <th>Upload Document</th>
                    <th>View</th>
                    <th>
                      <b-button
                        class="mt-2"
                        size="sm"
                        variant="outline-info"
                        @click="AddMoreDocs"
                        >Add More
                        <!-- @click="addQuotationFields" -->
                      </b-button>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in showDocSection" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <model-list-select
                        v-model="item.kycDocName"
                        :disabled="permissionStatus"
                        :list="docList"
                        option-value="docV"
                        option-text="docT"
                        placeholder="Select Document"
                      ></model-list-select>
                    </td>

                    <td>
                      <md-input-container style="margin-top: -35px">
                        <md-file
                          @selected="onFileChangeKyc(index, item.kycDocName)"
                          v-model="item.uploadedkycDoc"
                        ></md-file>
                      </md-input-container>
                    </td>

                    <td>
                      <!-- :href="
                        `${docURL}/`+`${item.uploadedkycDoc.includes('CLIENTKYCDOC') ? '':'CLIENTKYCDOC/'}` + item.uploadedkycDoc
                      " -->
                      <u
                        class="showMoreData"
                        style="cursor: pointer; color: blue;"
                        @click="viewKycDocument(item)"
                        v-if="item.uploadedkycDoc != ''"
                        >View Document - {{ index + 1 }}</u
                      >
                      <!-- {{
                        `${docURL}/` +
                        `${
                          item.uploadedkycDoc.includes("CLIENTKYCDOC")
                            ? ""
                            : "CLIENTKYCDOC/"
                        }` +
                        item.uploadedkycDoc
                      }} -->
                      <!-- <a
                        @click="
                          previewPrivateDocs(
                            `${
                              item.uploadedkycDoc.includes('CLIENTKYCDOC')
                                ? item.uploadedkycDoc.replace('CLIENTKYCDOC/', '').trim()
                                : item.uploadedkycDoc
                            }`
                          )
                        "
                        class="showMoreData"
                        v-if="item.uploadedkycDoc != ''"
                        target="_blank"
                        download
                        ><u>View Document - {{ index + 1 }}</u></a
                      > -->
                    </td>

                    <td>
                      <b-button
                        variant="outline-danger"
                        @click="removeDoc(index)"
                        size="sm"
                        >Remove</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- <div class="gutr" v-if="clientDetail.isKYC == 'Yes'">
            
              
                    <md-layout
                      md-gutter
                      v-for="(items, index) in showDocumentArray"
                      :key="index"
                      style="margin-top: 2%"
                    >
                      <md-layout md-flex="5"></md-layout>
                      <md-layout :md-flex="items.flex">
                        <span>
                          <b>{{ items.show }}</b>
                        </span>
                      </md-layout>
                      <md-layout md-flex="5">
                        <h3>:</h3>
                      </md-layout>
                      <md-layout md-flex="30" style="margin-top: -2%">
                        <md-layout md-flex="100">
                          <md-input-container>
                            <label>Click to Upload {{ items.show }}</label>
                            <md-file
                              :name="items.value"
                              :id="items.value"
                              v-model="clientDetail[items.value]"
                              @selected="onFileChange(items.value)"
                              :disabled="permissionStatus"
                              :multiple="
                                items.show == 'Other Document' ? true : false
                              "
                            ></md-file>
                          </md-input-container>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout
                        :md-flex="15"
                        v-if="
                          items.show != 'Other Document' &&
                          clientDetail[items.value] != ''
                        "
                      >
                        <a
                          href="javascript:void(0)"
                          @click="viewClientDocument(items.url, clientDetail[items.value])"
                          >View {{ items.show }}</a
                        >
                      </md-layout>
                      <md-layout
                        md-flex="10"
                        v-else-if="
                          items.show == 'Other Document' &&
                          clientDetail[items.value] != ''
                        "
                        v-for="(item, index) in otherDocument"
                        :key="index"
                      >
                        <a href="javascript:void(0)" @click="viewClientDocument(items.url, item)"
                          >Document - {{ index + 1 }}</a
                        >
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter v-if="clientDetail.isKYC == 'Yes'">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label>Remark (Other Document)</label>
                          <b-form-textarea :formatter="(value) => value.toUpperCase()"
                            name="remarkOtherDocument"
                            id="remarkOtherDocument"
                            v-model="clientDetail.remarkOtherDocument"
                          ></b-form-textarea>
                        </md-layout>
                 
                      </md-layout>
                    </md-layout>

                  
            </div> -->

            <!-- <md-layout md-gutter class="mrgtop-3per">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <b>TDS :</b>
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="istds1"
                  name="istds1"
                  v-model="clientDetail.isTds"
                  md-value="Yes"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >Yes</md-radio
                >
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="istds2"
                  name="istds2"
                  v-model="clientDetail.isTds"
                  md-value="No"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >No</md-radio
                >
              </md-layout>
            </md-layout> -->
            <md-layout md-gutter>
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Remark </label>
                  <b-form-textarea
                    :formatter="(value) => value.toUpperCase()"
                    name="remarkOtherDocument"
                    id="remarkOtherDocument"
                    v-model="clientDetail.remarkOtherDocument"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>

              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Branch </label>
                  <multi-select
                    :options="$store.getters['common/getAllBranchList']"
                    :selected-options="branch_items"
                    v-model="clientDetail.branchID"
                    placeholder="Select Branch"
                    :multiple="true"
                    id="Client"
                    @select="SelectMultiBranch"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                  ></multi-select>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="65">
                <md-layout md-flex="100">
                  <label>Users </label>
                  <multi-select
                    :options="activeUserList"
                    :selected-options="user_items"
                    v-model="clientDetail.userID"
                    placeholder="Select User"
                    :multiple="true"
                    id="User"
                    @select="SelectMultiUser"
                    :isDisabled="branch_items.length <= 0 ? true : false"
                  ></multi-select>
                </md-layout>
              </md-layout>
               <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="30">
                <label for="is_nomination_shipper">Is Nomination Shipper</label>
                <model-list-select
                  :disabled="permissionStatus"
                  :list="nominationShipperList"
                  v-model="clientDetail.is_nomination_shipper"
                  option-value="value"
                  option-text="text"
                  placeholder="Select Option"
                ></model-list-select>
              </md-layout>
            <!-- </md-layout>
            <md-layout md-gutter> -->
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="65">
                <md-layout md-flex="100">
                  <label>Sales Person</label>
                 
                  <CustomMultiSelect
                    :options="$store.getters['common/getAllUserList']"
                    :selected-options="salesPerson_items"
                    v-model="clientDetail.salesPersonID"
                    placeholder="Select Sales Person"
                    :multiple="true"
                    @select="SelectMultiSalesPerson"
                  ></CustomMultiSelect>

                  <!-- :disabled="salesPerson_items.length <= 0 ? true : false" -->
                    
                </md-layout>
              </md-layout>
            </md-layout>
            
            <!-- <md-layout
              md-gutter
              class="gutr"
              v-if="clientDetail.isTds == 'Yes'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>TDS Section</label>
                  <model-list-select
                    :isDisabled="permissionStatus"
                    :list="sectionRuleName"
                    v-model="clientDetail.sectionRule"
                    option-value="sectionRuleVal"
                    option-text="sectionRuleText"
                    placeholder="Select "
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>TDS Status</label>

                  <model-list-select
                    :isDisabled="permissionStatus"
                    :list="tdsStatusName"
                    v-model="clientDetail.tdsStatus"
                    option-value="tdsStatusVal"
                    option-text="tdsStatusText"
                    placeholder="Select"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>TDS Rate</label>

                  <model-list-select
                    :isDisabled="permissionStatus"
                    :list="tdsPercentageName"
                    v-model="clientDetail.tdsPercentage"
                    option-value="tdsPercentageVal"
                    option-text="tdsPercentageText"
                    placeholder="Select"
                  ></model-list-select>
                </md-layout>
              </md-layout>
            </md-layout> -->
            <b-row>
              <b-col cols="12">
                <label :style="'color:blue'">Generic Container Details</label>
                <table class="table table-sm table-bordered mt-2">
                  <tbody style="background: white">
                    <tr>
                      <th scope="col" style="width: 5px">SN.</th>
                      <th scope="col" style="width: 200px">Container Type</th>
                      <th scope="col" style="width: 200px">Total Container</th>
                      <th scope="col" style="width: 180px">Tues Val</th>
                      <th scope="col" style="width: 180px">Enq No</th>
                      <th scope="col" style="width: 180px">Remark</th>
                      <th>
                        Action
                        <b-button
                          variant="outline-danger"
                          @click="addLeadCont()"
                          size="sm"
                          >Add</b-button
                        >
                      </th>
                    </tr>
                    <tr v-for="(item, index) in allClientContMapList" :key="index">
                      <th scope="row">{{ index + 1 }}.</th>
                      <td>
                        <model-list-select
                          :list="$store.getters['common/getAllContainerTypeList']"
                          v-model="item.fk_cont_type_id"
                          option-value="containerTypeId"
                          option-text="containerType"
                          placeholder="Select Container Type"
                        ></model-list-select>
                        <span
                          class="error"
                          v-if="item.fk_cont_type_id_err ? true : false"
                          >{{ item.fk_cont_type_id_err }}</span
                        >
                      </td>
                      <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.tot_continer"
                          type="number"
                          placeholder="Enter Total COntainer"
                        ></b-form-input>
                        <span class="error" v-if="item.tot_continer_err ? true : false">{{
                          item.tot_continer_err
                        }}</span>
                      </td>
                      <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.continer_tues_val"
                          type="number"
                          placeholder="Enter TUES Volume"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="item.continer_tues_val_err ? true : false"
                          >{{ item.continer_tues_val_err }}</span
                        >
                      </td>
                      <td>
                        {{ item.enq_no }}
                      </td>
                      <td>
                        <b-textarea
                          rows="2"
                          :formatter="capitalizeAll"
                          v-model="item.continer_remark"
                          type="text"
                          placeholder="Enter Remark"
                        ></b-textarea>
                      </td>
                      <td>
                        <b-button
                          :disabled="item.ccm_id > 0 ? true : false"
                          v-if="index > 0 && !item.ccm_id"
                          size="sm"
                          class="mb-1"
                          @click="removeLeadCont(index)"
                        >
                          <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        </b-button>
                        <b-button size="sm" @click="saveLeadCont(item)">
                          {{ item.ccm_id > 0 ? "Update" : "Save" }}
                        </b-button>
                        <span v-if="item.ccm_id > 0">{{
                          "Created At : " + item.created_at
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <b-col cols="12">
                <label :style="'color:blue'">Month Container Details</label>
                <table class="table table-sm table-bordered mt-2">
                  <tbody style="background: white">
                    <tr>
                      <th scope="col" style="width: 5px">SN.</th>
                      <th scope="col" style="width: 200px">From Date</th>
                      <th scope="col" style="width: 200px">To Date</th>
                      <th scope="col" style="width: 200px">Container Type</th>
                      <th scope="col" style="width: 200px">Total Container</th>
                      <th scope="col" style="width: 180px">Tues Val</th>
                      <th scope="col" style="width: 180px">Remark</th>
                      <th>
                        Action
                        <b-button
                          variant="outline-danger"
                          @click="addMonthCont()"
                          size="sm"
                          >Add</b-button
                        >
                      </th>
                    </tr>
                    <tr v-for="(item, index) in allClientContMonthMapList" :key="index">
                      <th scope="row">{{ index + 1 }}.</th>

                      <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.ccmm_date"
                          type="date"
                          placeholder="Enter Date"
                        ></b-form-input>
                        <span class="error" v-if="item.ccmm_date_err ? true : false">{{
                          item.ccmm_date_err
                        }}</span>
                      </td>
                      <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.ccmm_to_date"
                          type="date"
                          placeholder="Enter Date"
                        ></b-form-input>
                        <span class="error" v-if="item.ccmm_to_date_err ? true : false">{{
                          item.ccmm_to_date_err
                        }}</span>
                      </td>
                      <td>
                        <model-list-select
                          :list="$store.getters['common/getAllContainerTypeList']"
                          v-model="item.fk_cont_type_id"
                          option-value="containerTypeId"
                          option-text="containerType"
                          placeholder="Select Container Type"
                        ></model-list-select>
                        <span
                          class="error"
                          v-if="item.fk_cont_type_id_err ? true : false"
                          >{{ item.fk_cont_type_id_err }}</span
                        >
                      </td>
                      <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.tot_continer"
                          type="number"
                          placeholder="Enter Total COntainer"
                        ></b-form-input>
                        <span class="error" v-if="item.tot_continer_err ? true : false">{{
                          item.tot_continer_err
                        }}</span>
                      </td>
                      <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.continer_tues_val"
                          type="number"
                          placeholder="Enter TUES Volume"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="item.continer_tues_val_err ? true : false"
                          >{{ item.continer_tues_val_err }}</span
                        >
                      </td>
                      <td>
                        <b-textarea
                          rows="2"
                          :formatter="capitalizeAll"
                          v-model="item.continer_remark"
                          type="text"
                          placeholder="Enter Remark"
                        ></b-textarea>
                      </td>
                      <td>
                        <b-button
                          :disabled="item.ccmm_id > 0 ? true : false"
                          v-if="index > 0 && !item.ccmm_id"
                          size="sm"
                          @click="removeMonthCont(index)"
                          class="mb-1"
                        >
                          <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        </b-button>
                        <b-button size="sm" @click="saveMonthCont(item)">
                          {{ item.ccmm_id > 0 ? "Update" : "Save" }}
                        </b-button>
                        <span v-if="item.ccmm_id > 0">{{
                          "Created At : " + item.created_at
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <md-layout md-gutter v-if="clientDetail.isKYC == 'Yes'">
              <md-layout md-flex="5"></md-layout>
              <span class="error" v-if="clientDetail.panCard == ''">{{
                panCardError
              }}</span>
            </md-layout>

            <md-layout md-gutter v-if="clientDetail.isKYC == 'Yes'">
              <md-layout md-flex="5"></md-layout>

              <span class="error" v-if="clientDetail.aadharCard == ''">{{
                aadharError
              }}</span>
            </md-layout>
            <md-layout md-gutter class="mt-3">
              <md-layout class="justify-content-center">
                <b-button
                  class="smbutnWidth"
                  variant="primary"
                  :disabled="permissionStatus"
                  @click="addClient('csfds', 'AddClient')"
                  id="addButtonLoader"
                  >Save</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>

                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog
      class="HereDialog"
      md-open-from="#custom"
      md-close-to="#custom"
      ref="dialogLocation"
    >
      <md-dialog-content>
        <pickupLocation />
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeModalLocation">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      class="HereDialog"
      md-open-from="#custom"
      md-close-to="#custom"
      ref="dialog2"
    >
      <md-dialog-content>
        <div class="box margn-0px">
          <!-- /.box-header -->
          <div class="box-body">
            <md-layout md-gutter class="modal-header-set">
              <md-layout md-flex="40"></md-layout>
              <md-layout md-flex="55">
                <h2 style="margin: 7px">Contract Detail</h2>
              </md-layout>
              <md-layout md-flex="5">
                <md-button
                  class="md-icon-button md-raised md-dense modal-close-btnn"
                  @click="closeModal()"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-layout>
            </md-layout>

            <md-layout md-gutter style="margin-top: 15px">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Select Contract Type</label>
                  <model-list-select
                    :isDisabled="permissionStatus"
                    :list="contractListName"
                    v-model="contractDetailModal.contractType"
                    option-value="contractTypeVal"
                    option-text="contractTypeText"
                    placeholder="Select Contract Type "
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.contractType">{{
                  isContractError
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Validity From Date</label>
                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  v-model="contractDetailModal.fromValidity"
                  :disabled="permissionStatus"
                  id="Date"
                ></date-picker>
                <span class="error" v-if="!contractDetailModal.fromValidity">{{
                  isFromValidtyError
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Validity To Date</label>
                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  v-model="contractDetailModal.toValidity"
                  :disabled="permissionStatus"
                  id="Date"
                ></date-picker>
                <span class="error" v-if="!contractDetailModal.toValidity">{{
                  isToValidtyError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Monthly fixed rental for each dedicated vehicle</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="monthlyRent"
                    name="monthlyRent"
                    v-model="contractDetailModal.monthlyRent"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.monthlyRent">{{
                  isMonthlyRentError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Number of dedicated vehicles</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    id="noOfTrucks"
                    name="noOfTrucks"
                    v-model="contractDetailModal.noOfTrucks"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.noOfTrucks">{{
                  noOfTrucksError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="gutr"
              v-if="contractDetailModal.contractType == 'fuelType'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Mileage</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="milage"
                    name="milage"
                    v-model="contractDetailModal.milage"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.milage">{{
                  milageError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Diesel Rate</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    id="dieselRate"
                    name="dieselRate"
                    v-model="contractDetailModal.dieselRate"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.dieselRate">{{
                  dieselRateError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="gutr"
              v-if="contractDetailModal.contractType == 'freeKMType'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Free Kilometer per vehicle per months</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="allowedKm"
                    name="allowedKm"
                    v-model="contractDetailModal.allowedKm"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.allowedKm">{{
                  isAllowedKmError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Vehicle Modal</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="vehicleModal"
                    name="vehicleModal"
                    v-model="contractDetailModal.vehicleModal"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.vehicleModal">{{
                  vehicleModalError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Vehicle Type</label>
                <model-list-select
                  :isDisabled="permissionStatus"
                  :list="vehicleTypeMaster"
                  v-model="contractDetailModal.vehicleType"
                  option-value="vehicleTypeId"
                  option-text="vehicleType"
                  placeholder="Select Vehicle Type "
                ></model-list-select>

                <span class="error" v-if="!contractDetailModal.vehicleType">{{
                  vehicleTypeError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Gross Weight</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="grossWeight"
                    name="grossWeight"
                    v-model="contractDetailModal.grossWeight"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.grossWeight">{{
                  grossWeightError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="gutr"
              v-if="contractDetailModal.contractType == 'freeKMType'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Additional charges over allowed Km</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="overcharges"
                    name="overcharges"
                    v-model="contractDetailModal.overcharges"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.overcharges">{{
                  isOverChargesError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="5"></md-layout>
            </md-layout>

            <md-layout md-gutter class="mrgtop-2per">
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">Note:-</h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                1:Toll/Green Tax to be paid actual against receipt.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                2:Penalty/Challans/RTO will be borne by the Transporter.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                3:Cooling period will be 2 days in a month.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                4:Diesel, Driver & Maintenance will be borne by the Transporter..
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                5:Documents will be Insurance, RC Copy, Permit, Fitness Certificate of the
                attached vehicle should be provided at the time of agreement.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                6: Goods & Service Tax(GST) as per applicable law.
              </h4>
            </md-layout>
          </div>
          <!-- /.box-body -->
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="addContract">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="PopDoc"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopSave"
      @close="onClose"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
      @close="onClose1"
      style="z-index: 99999999999999"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseDelete"
      ref="addPopDeleteF"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import Vue from "vue";
// import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import pickupLocation from "../locationMaster/pickupLocation.vue";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import ClientUserService from "../../../services/ClientUserService.js";
import CustomMultiSelect from "../../common/CustomMultiSelect.vue";

import AccountService from "../../../services/AccountService.js";
export default {
  beforeMount() {
    this.getMultiUserBasedonBranch("All");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
      this.$store.dispatch("setCurrentRoute", "/client/addClient");
      this.getSegmentData();
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
      this.viewEditClient(this.$sessionsStorage.get("editClientId"));
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  props: {
    clientIdSales: String,
  },
  data() {
    return {
      fk_client_id: "",
      fk_lead_id: "",
      fk_enq_id: "",
      enq_no: "",
      allClientContMonthMapList: [],
      allClientContMapList: [],

      fileList: [],
      uploadedFiles: [],
      presignedUrls: [],

      activeUserList: [],
      branch_items: [],
      user_items: [],
      salesPerson_items: [],
      selectDateFormat,
      showDocSection: [],
      contactPersonArry: [],
      docURL: URL_BASE_DOC,
      sectionRuleName: [
        {
          sectionRuleVal: "194A",
          sectionRuleText: "194A",
        },
        {
          sectionRuleVal: "194C",
          sectionRuleText: "194C",
        },
        {
          sectionRuleVal: "194H",
          sectionRuleText: "194H",
        },
        {
          sectionRuleVal: "194I",
          sectionRuleText: "194I",
        },
        {
          sectionRuleVal: "194J",
          sectionRuleText: "194J",
        },
      ],

      tdsStatusName: [
        {
          tdsStatusVal: "Individual_HUF",
          tdsStatusText: "Individual/HUF",
        },
        {
          tdsStatusVal: "Other_Than_Individual_HUF",
          tdsStatusText: "Other Than Individual HUF",
        },
        {
          tdsStatusVal: "Any_In_Case_Plant_Machinery",
          tdsStatusText: "Any In Case Plant Machinery",
        },
        {
          tdsStatusVal: "Any_In_Case_Land_Building",
          tdsStatusText: "Any In Case Land Building",
        },
      ],
      tdsPercentageName: [
        {
          tdsPercentageVal: "1%",
          tdsPercentageText: "1",
        },
        {
          tdsPercentageVal: "2%",
          tdsPercentageText: "2%",
        },
        {
          tdsPercentageVal: "5%",
          tdsPercentageText: "5%",
        },
        {
          tdsPercentageVal: "10%",
          tdsPercentageText: "10%",
        },
      ],
      clientTypeList: [
        {
          clientTypeVal: "Client",
          clientTypeText: "Client",
        },

        {
          clientTypeVal: "Overseas",
          clientTypeText: "Overseas",
        },
        {
          clientTypeVal: "Lead",
          clientTypeText: "Lead",
        },
        {
          clientTypeVal: "Transporter",
          clientTypeText: "Transporter",
        },
        {
          clientTypeVal: "Trader",
          clientTypeText: "Trader",
        },
        {
          clientTypeVal: "Freight_Forwarder",
          clientTypeText: "Freight Forwarder",
        },
        {
          clientTypeVal: "Consignee",
          clientTypeText: "Consignee",
        },
        // {
        //   clientTypeVal: "CHA",
        //   clientTypeText: "CHA"
        // }
      ],
      nominationShipperList: [
        { text: "Yes", value: "1" },
        { text: "No", value: "0" },
      ],
      contractListName: [
        {
          contractTypeVal: "fuelType",
          contractTypeText: "Fuel Type",
        },
        {
          contractTypeVal: "freeKMType",
          contractTypeText: "Free KM Type",
        },
      ],
      docList: [
        {
          docV: "PAN_CARD",
          docT: "PAN CARD",
        },
        {
          docV: "ADDRESS_PROOF",
          docT: "ADDRESS PROOF",
        },
        {
          docV: "GST Certificate",
          docT: "GST Certificate",
        },
        {
          docV: "TAN",
          docT: "TAN",
        },
        {
          docV: "IEC",
          docT: "IEC",
        },
        {
          docV: "KYC",
          docT: "KYC",
        },
        {
          docV: "OTHERS",
          docT: "OTHERS",
        },
      ],

      companyPermitList: [
        {
          permitVal: "GSTRegistered",
          permitText: "GST Registered",
        },
        {
          permitVal: "GSTUnregistered",
          permitText: "GST Unregistered",
        },
        {
          permitVal: "SEZ",
          permitText: "SEZ",
        },
      ],
      companyTypeList: [
        {
          companyTypeVal: "Propreitorship",
          companyTypeText: "Propreitorship",
        },
        {
          companyTypeVal: "Partnership",
          companyTypeText: "Partnership",
        },
        {
          companyTypeVal: "privateLimited",
          companyTypeText: "Private Limited",
        },
        {
          companyTypeVal: "publicLimited",
          companyTypeText: "Public Limited",
        },
        {
          companyTypeVal: "HUF",
          companyTypeText: "HUF",
        },
        {
          companyTypeVal: "LLP",
          companyTypeText: "LLP",
        },
      ],

      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      factoryModal: {
        longitude: "",
        latitude: "",

        multiFactoryId: "",
        clientId: "",
        location: "",
        GSTIN1: "",
        factoryAddress1: "",
        factoryTitle: "",
      },
      errorEmailFormat: "",
      getLocationData: [],
      viewAllFactory: [],
      clientDetail: {
        access_user_json: [],
        access_branch_json: [],
        access_salesPerson_json: [],
        branchID: "",
        branchName: "",
        userID: "",
        userName: "",
        salesPersonID: "",
        salesPersonName: "",
        stateCode: "",
        clientId: "",
        clientName: "",
        IEC: "",
        companyType: "",
        kycContact: "",
        hireContract: "",
        state: "",
        corporateAddress: "",
        remarkOtherDocument: "",
        segment: [],
        contractTerm: "",
        rateSigned: "",
        rateDiesel: "",
        paymentTerms: "",
        tolls: "",
        uploadKYC: "",

        factoryAddress2: "",
        GSTIN2: "",
        isContract: "",
        contractId: "",
        detentionPeriod: "",
        email: "",
        isKYC: "",
        isTds: "",
        sectionRule: "",
        tdsPercentage: "",
        tdsStatus: "",
        altMail: "",

        voterCard: "",
        panCard: "",
        aadharCard: "",
        nameKYC: "",
        emailKYC: "",
        phoneKYC: "",
        contactPersonDept: "",
        contactPersonDegination: "",
        customs: "",
        accounts: "",
        creditDays: "",
        GSTN: "",
        panNO: "",
        tanNO: "",
        accountManager: "",
        permitted: "",
        clientType: "",
        is_nomination_shipper: "0",
      },
      contractDetailModal: {
        contractId: "",
        fromValidity: "",
        toValidity: "",
        contractType: "",
        // contractSeries: "",
        allowedKm: "",
        monthlyRent: "",
        overcharges: "",
        vehicleModal: "",
        vehicleType: "",
        grossWeight: "",
        noOfTrucks: "",
        milage: "",
        dieselRate: "",
      },
      mobileValid: "",
      vehicleTypeMaster: [],
      alert: {
        content:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? " Data Updated Succesfully"
            : " Added Succesfully ",
        ok: "ok",
      },

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? "Update"
            : "New",
      },
      contractTable: [],
      employeeMaster: [],

      showSegmentArray: [],
      showDocumentArray: [],
      stateDetail: [],
      clientError: "",
      corporateAddressError: "",
      permittedError: "",
      clientTypeError: "",
      stateError: "",
      panNOError: "",
      segmentError: "",
      multiFactError: "",
      factoryAddress1Error: "",
      factoryTitleError: "",
      locationError: "",
      phoneKYCError: "",
      tanNOError: "",
      GSTNError: "",
      GSTNErrorValid: "",
      isContractError: "",
      isContractError1: "",
      hireContractError: "",
      isFromValidtyError: "",
      isToValidtyError: "",
      isContractError: "",
      isOverChargesError: "",
      hireContractError: "",
      isAllowedKmError: "",
      noOfTrucksError: "",
      vehicleModalError: "",
      vehicleTypeError: "",
      grossWeightError: "",
      milageError: "",
      dieselRateError: "",
      panCardError: "",
      aadharError: "",
      isMonthlyRentError: "",
      PANErrorValid: "",
      TANErrorValid: "",
      emailErrorValid: "",
      emailError: "",
      companyTypeError: "",
      // detentionPeriodError: "",
      validate: true,
      count: 0,
      isLoading: false,
    };
  },

  mounted() {
    if (
      this.$sessionsStorage.get("editClientId") == null &&
      this.$sessionsStorage.get("editClientId") == undefined
    ) {
      this.count = 2;
    }
    if (
      this.$sessionsStorage.get("editClientType") != "" &&
      this.$sessionsStorage.get("editClientType") != undefined
    ) {
      this.clientDetail.clientType = this.$sessionsStorage.get("editClientType");
    }
  },
  beforeDestroy() {
    // this.$sessionsStorage.set("editClientId", "");
    // this.$sessionsStorage.set("editClientType", "");
  },
  destroyed() {},
  components: {
    pickupLocation,
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
    CustomMultiSelect,
  },
  computed: {
    otherDocument() {
      return this.clientDetail.uploadKYC.split(",");
    },
    employeeMasterList() {
      return this.employeeMaster;
    },
    stateListData() {
      return this.stateDetail;
    },
    locationList() {
      return this.getLocationData;
    },
  },
  watch: {
    // clientIdSales: {
    //   handler: function (newVal, oldVal) {
    //     if (newVal != "") {
    //       this.viewEditClient(newVal);
    //       this.getTypeSize(newVal);
    //     }
    //   },

    //   deep: true,
    // },

    clientDetail: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("GSTN", "panNO", "tanNO")) {
          this.clientDetail.GSTN = newVal.GSTN.toUpperCase();
          this.clientDetail.panNO = newVal.panNO.toUpperCase();
          this.clientDetail.tanNO = newVal.tanNO.toUpperCase();
        }

        if (this.clientDetail.state != "") {
          let arrayNew = this.stateDetail.filter((x) => {
            return x.stateId == this.clientDetail.state;
          });

          if (arrayNew.length > 0) {
            this.clientDetail.stateCode = arrayNew[0].gstCode;

            // this.cliearrayNew[0]
          }
        }
      },
      deep: true,
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  methods: {
    viewKycDocument(item) {
      if (!item.uploadedkycDoc) return;
      let key =
        (item.uploadedkycDoc.includes("CLIENTKYCDOC") ? "" : "CLIENTKYCDOC/") +
        item.uploadedkycDoc;
      this.openSignedDocument(key);
    },
    viewClientDocument(prefix, filename) {
      if (!filename) return;
      this.openSignedDocument(prefix + filename);
    },
    removeLeadCont(index) {
      this.allClientContMapList.splice(index, 1);
    },
    addLeadCont() {
      let obj = {
        fk_cont_type_id: "",
        continer_tues_val: "",
        tot_continer: "",
        fk_lead_id: this.fk_lead_id,
        fk_enq_id: this.fk_enq_id,
        fk_client_id: this.$sessionsStorage.get("editClientId"),
        enq_no: this.enq_no,
        ccm_id: "",
        continer_remark: "",
      };
      this.allClientContMapList.push(obj);
    },

    addMonthCont() {
      let obj = {
        fk_cont_type_id: "",
        continer_tues_val: "",
        tot_continer: "",
        month_no_val: "",
        month_name_val: "",
        year_no_val: "",
        year_name_val: "",
        ccmm_date: "",
        ccmm_to_date: "",
        fk_client_id: this.$sessionsStorage.get("editClientId"),
        ccmm_id: "",
        continer_remark: "",
      };
      this.allClientContMonthMapList.push(obj);
    },
    removeMonthCont(index) {
      this.allClientContMonthMapList.splice(index, 1);
    },
    saveLeadCont(item) {
      let payload = {
        itemCode: "upsertClientContMap",
        containerData: item,
      };
      AccountService.getAllContractList(payload)
        .then(async (response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.FLAG == 1) {
            await this.getContainerLeadGeneralMap(
              this.$sessionsStorage.get("editClientId")
            );
          }
          this.alert.content = data.MSG;
          this.$refs["addPop"].open();
        })
        .catch((error) => {
          console.log("Catch on saveLeadCont Error: ", error);
        });
    },
    formatDate(item, dateString) {
      const date = new Date(dateString);

      // Month number (0-11) + 1 to make it (1-12)
      item.month_no_val = date.getMonth() + 1;
      item.month_no_val =
        item.month_no_val < 10 ? `0${item.month_no_val}` : `${item.month_no_val}`;

      // Month name
      item.month_name_val = date.toLocaleString("default", { month: "long" });

      // Year number
      item.year_no_val = date.getFullYear();

      // Year name (you can format it as you like, here just using the year number)
      item.year_name_val = item.year_no_val.toString();
    },
    saveMonthCont(item) {
      this.formatDate(item, item.ccmm_date);
      let payload = {
        itemCode: "upsertClientContMonthMap",
        containerData: item,
      };
      AccountService.getAllContractList(payload)
        .then(async (response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.FLAG == 1) {
            await this.getContainerLeadGeneralMap(
              this.$sessionsStorage.get("editClientId")
            );
          }

          this.alert.content = data.MSG;
          this.$refs["addPop"].open();
        })
        .catch((error) => {
          console.log("Catch on saveMonthCont Error: ", error);
        });
    },

    SelectMultiBranch(branch_items, lastSelectItem) {
      this.user_items = [];
      this.salesPerson_items = [];
      this.clientDetail.userID = "";
      this.clientDetail.salesPersonID = "";
      this.branch_items = branch_items;
      console.log("branch_items=>", this.branch_items);

      this.clientDetail.branchID = "";
      this.clientDetail.branchName = "";
      if (this.branch_items) {
        this.branch_items.forEach((item_val) => {
          if (this.clientDetail.branchName) {
            this.clientDetail.branchName =
              this.clientDetail.branchName + "," + item_val.text;
          } else {
            this.clientDetail.branchName = item_val.text;
          }

          if (this.clientDetail.branchID) {
            this.clientDetail.branchID =
              this.clientDetail.branchID + "," + item_val.value;
          } else {
            this.clientDetail.branchID = item_val.value;
          }
        });
        console.log("clientDetail=>", this.clientDetail);
      }

      this.clientDetail.access_user_json = this.user_items;
      this.clientDetail.access_branch_json = this.branch_items;
      this.getMultiUserBasedonBranch(2);
    },
    getMultiUserBasedonBranch(typeData) {
      return new Promise((resolve) => {
        this.activeUserList = [];
        if (this.branch_items.length > 0 || typeData == "All") {
          let editClientBranchId = null;
          if (
            this.$sessionsStorage.get("editClientBranchId") == "undefined" ||
            this.$sessionsStorage.get("editClientId") == "null" ||
            this.$sessionsStorage.get("editClientId") == undefined ||
            this.$sessionsStorage.get("editClientId") == null ||
            this.$sessionsStorage.get("editClientId") == ""
          ) {
            editClientBranchId = null;
          } else {
            editClientBranchId = this.$sessionsStorage.get("editClientBranchId");
          }
          let payload = {
            itemCode: "getAllMasterUser",
            UserForm: {
              branchID:
                typeData == "All" ? editClientBranchId : this.clientDetail.branchID,
              branchName: this.clientDetail.branchName,
              branch_items: this.branch_items,
              status: 1,
              type: 1, //1:user,2:client
            },
          };
          payload = JSON.stringify(payload);
          // return false;
          ClientUserService.getAllClientUserList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (status == 200) {
                this.activeUserList = [];
                this.activeUserList = data.UserList;
              }
              return resolve(status == 200 ? true : false);
            })
            .catch((error) => {
              console.log("Catch on Proforma Error: ", error);
            });
        }
      });
    },
    SelectMultiUser(user_items, lastSelectItem) {
      this.user_items = user_items;
      console.log("user_items=>", this.user_items);

      this.clientDetail.userID = "";
      this.clientDetail.userName = "";
      if (this.user_items) {
        this.user_items.forEach((item_val) => {
          if (this.clientDetail.userName) {
            this.clientDetail.userName = this.clientDetail.userName + "," + item_val.text;
          } else {
            this.clientDetail.userName = item_val.text;
          }

          if (this.clientDetail.userID) {
            this.clientDetail.userID = this.clientDetail.userID + "," + item_val.value;
          } else {
            this.clientDetail.userID = item_val.value;
          }
        });
        console.log("clientDetail=>", this.clientDetail);
      }
      this.clientDetail.access_user_json = this.user_items;
    },
    SelectMultiSalesPerson(salesPerson_items) {
      this.salesPerson_items = salesPerson_items;
      console.log("salesPerson_items=>", this.salesPerson_items);

      this.clientDetail.salesPersonID = "";
      this.clientDetail.salesPersonName = "";
      if (this.salesPerson_items && this.salesPerson_items.length > 0) {
        this.salesPerson_items.forEach((item_val) => {
          if (this.clientDetail.salesPersonName) {
            this.clientDetail.salesPersonName = this.clientDetail.salesPersonName + "," + item_val.text;
          } else {
            this.clientDetail.salesPersonName = item_val.text;
          }

          if (this.clientDetail.salesPersonID) {
            this.clientDetail.salesPersonID = this.clientDetail.salesPersonID + "," + item_val.value;
          } else {
            this.clientDetail.salesPersonID = item_val.value;
          }
        });
        console.log("clientDetail salesPerson=>", this.clientDetail);
      }
      this.clientDetail.access_salesPerson_json = this.salesPerson_items;
    },

    previewPrivateDocs(item) {
      let paylod = {
        privateDocName: item,
        id: "Client_Kyc",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/viewPrivateDoc.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.status == "success") {
              this.openSignedDocument(`CLIENTKYCDOC/${item}`);
              // window.open(`${this.docURL}/templibblock/` + item);
            } else {
              this.alert.content = "Document Not Found";
              this.$refs["PopDoc"].open();
            }
          }
        })
        .catch((error) => {});

      // :href="
      //                         `${docURL}/CLIENTKYCDOC/` +
      //                         item.uploadedkycDoc
      //                       "
    },
    removeDoc(index) {
      this.showDocSection.splice(index, 1);
    },
    AddMoreDocs() {
      let obj = {
        kycDocName: "",
        uploadedkycDoc: "",
      };
      this.showDocSection.push(obj);
    },

    removeCp(index) {
      this.contactPersonArry.splice(index, 1);
    },
    AddMoreContactP() {
      let obj = {
        name: "",
        email: "",
        phone: "",
        dept: "",
        deg: "",
      };
      this.contactPersonArry.push(obj);
    },

    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    fetchLatLog() {
      let options = {
        method: "GET",
        url:
          // `https://www.mapquestapi.com/geocoding/v1/address?key=OTLGZmcN6qXiHnH4qSU4lXTYWLPEoINP&location=` +
          `https://www.mapquestapi.com/geocoding/v1/address?key=AiBjJ4PC52j31H0BO1xlTTXDHIAZwDD0&location=` +
          this.factoryModal.factoryAddress1,
      };

      axios(options)
        .then((result) => {
          console.log(result.data.results[0].locations[0].displayLatLng);
          this.factoryModal.latitude =
            result.data.results[0].locations[0].displayLatLng.lat;
          this.factoryModal.longitude =
            result.data.results[0].locations[0].displayLatLng.lng;
        })
        .catch((error) => {});
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPopDeleteF"].open();
    },
    onCloseDelete(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "client_multi_factory",
          tableId: "multiFactoryId",
          tableIsActive: "isMultifactoryActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.JqueryFun();
              this.getTypeSize(this.$sessionsStorage.get("editClientId"));
              // console.log(data);
            }
          })
          .catch((error) => {});
      }
    },
    isEmailValid() {
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.clientDetail.email)) {
        this.errorEmailFormat = "";
      } else {
        this.errorEmailFormat = "Enter Valid Email";
      }
    },
    EditFactory(item) {
      this.$refs["my-modal"].show();
      Object.keys(this.factoryModal).map((x) => {
        this.factoryModal[x] = item[x] || "";
      });
    },
    closeModal() {
      this.$refs["dialog2"].close();
    },
    closeModalLocation() {
      this.$refs["dialogLocation"].close();
      this.getTypeSize(this.$sessionsStorage.get("editClientId"));
    },
    viewContract(contractId) {
      this.$sessionsStorage.set("editContractId", contractId);
      this.$router.push({
        path: "/viewHireContract",
      });
    },
    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter((x) => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
    },
    getFormatDateTime() {
      // Parse the originalDateTime string into a JavaScript Date object
      // Set originalDateTime to the current date and time
      let originalDateTime = new Date();

      // Extract individual components (optional)
      const year = originalDateTime.getFullYear();
      const month = originalDateTime.getMonth() + 1; // January is 0
      const day = originalDateTime.getDate();
      const hour = originalDateTime.getHours();
      const minute = originalDateTime.getMinutes();

      // Format the date and time as "YYYYMMDDHHmm"
      const formattedDateTime = `${year}${month
        .toString()
        .padStart(2, "0")}${day.toString().padStart(2, "0")}${hour
        .toString()
        .padStart(2, "0")}${minute.toString().padStart(2, "0")}`;

      // Display the formatted date and time
      console.log(formattedDateTime); // Output: "202405021250"
      return formattedDateTime;
    },
    onFileChangeKyc(index, DOCNAME) {
      this.fileList = [];
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        this.fileList.push({
          name: files[i].name,
          progress: 0,
          file: files[i],
        });
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editClientId") +
            "-" +
            index +
            "_" +
            this.getFormatDateTime()
        );
        formData.append("staticFileName", this.clientDetail.clientName + "_" + DOCNAME);
        formData.append("upload_dir_folderName", "CLIENTKYCDOC");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllCorrect.php`, formData, config)
        .then(async (result) => {
          this.showDocSection[index].uploadedkycDoc = result.data.imgPath;
          const fileData = {
            folderName: this.folderName,
            documentName: this.documentName,
            url: result.data.imgPath,
          };
          this.presignedUrls = result.data.presignedUrlArr;
          this.uploadedFiles = result.data.imgPath.split(",");
          await this.uploadFiles();
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },
    async uploadFiles() {
      try {
        // Iterate through files and upload each one using the corresponding pre-signed URL
        for (let i = 0; i < this.fileList.length; i++) {
          const file = this.fileList[i].file;
          const presignedUrl = this.presignedUrls[i];

          // Perform file upload using Axios PUT request
          await this.uploadFileToS3(file, presignedUrl, i);
        }
      } catch (error) {
        console.error("Error uploading files:", error);
      }
    },
    uploadFileToS3(file, presignedUrl, i) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", presignedUrl, true);
        xhr.setRequestHeader("Content-Type", file.type);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = (event.loaded / event.total) * 100;
            file.progress = Math.round(progress);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
            // this.CopyAWSToServer();
          } else {
            reject(`Upload failed with status ${xhr.status}`);
          }
        };

        xhr.onerror = () => {
          reject("Upload failed due to network error.");
        };

        xhr.send(file);
      });
    },
    getTypeSize(idCl) {
      this.isLoading = true;
      let type_Size = {
        truckTS: "truckTS",

        clientId: idCl,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchTypeSizeTruck.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.truckTypeDetails.length > 0) {
              this.vehicleTypeMaster = data.truckTypeDetails;
            } else {
              this.vehicleTypeMaster = [];
            }
            if (data.factoryLocationData.length > 0) {
              this.getLocationData = data.factoryLocationData;
            } else {
              this.getLocationData = [];
            }
            if (data.multiFactoryData.length > 0) {
              this.viewAllFactory = data.multiFactoryData;
            } else {
              this.viewAllFactory = [];
            }

            this.isLoading = false;

            if (
              this.$sessionsStorage.get("editClientId") != "" &&
              this.$sessionsStorage.get("editClientId") != undefined
            ) {
            } else {
              this.clientDetail.accountManager = data.UserDetail1[0].employeeName;
            }
          }
        })
        .catch((error) => {});
    },

    onClose(type) {
      this.$router.push({
        path: "/client/viewClient",
      });
    },
    previousClientView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/client/viewClient"
      //   // params:{
      //   //   "userId":res.data.Id,
      //   // }
      // });
    },
    hireModel() {
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      let contractFilter = contractTable.filter((y) => {
        let validDate = new Date(y.toValidity);

        return y.clientId == this.clientListData.clientId && validDate > currentDate;
      });

      if (contractFilter.length > 0) {
        this.$sessionsStorage.set("setContractId", contractFilter[0].contractId);
        this.$sessionsStorage.set("clientId", this.clientListData.clientId);
        this.$router.push({
          path: "/listView/hireModel",
        });
      } else {
        this.alert.content =
          "Please add a new contract . Your Contract validity is out of date.";
        this.$refs["addPop1"].open();
      }
    },

    onClose1(type) {
      let payload = {
        contractId: this.clientDetail.contractId,
      };
      if (this.clientDetail.clientId != "") {
        payload["clientId"] = this.clientDetail.clientId;
      } else {
        payload["clientId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/viewContractTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.contractArray.length > 0) {
              this.contractTable = data.contractArray;
            }

            this.JqueryFun();
            this.$refs["addPop1"].close();
          }
        })
        .catch((error) => {});
    },
    JqueryFun() {
      $(function () {
        return $("#contracthireModel").DataTable();
        return $("#factoryDetails").DataTable();
      });
    },

    async viewEditClient(id) {
      let checkValueExit = await this.getMultiUserBasedonBranch("All");
      await this.getContainerLeadGeneralMap(id);
      this.isLoading = true;
      let edit_Client = {
        edit: "edit",
        clientId: id,
      };

      if (checkValueExit == true) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/viewEditClient.php`,
          data: JSON.stringify(edit_Client),

          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        await axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            let array = [];
            let array1 = [];

            if (status == 200 && data) {
              if (data.editClient.length > 0) {
                if (
                  data.editClient[0].uploadedkycDoc != null &&
                  data.editClient[0].uploadedkycDoc != ""
                ) {
                  let uploadedDocName = [];
                  let uploadedDoc = data.editClient[0].uploadedkycDoc.split(",");
                  if (
                    data.editClient[0].uploadedkycDoc &&
                    data.editClient[0].isKYC == "Yes"
                  ) {
                    uploadedDocName = data.editClient[0].kycDocName.split(",");
                    for (let i = 0; i < uploadedDoc.length; i++) {
                      let obj = {
                        kycDocName: uploadedDocName[i],
                        uploadedkycDoc: uploadedDoc[i],
                      };
                      this.showDocSection.push(obj);
                    }
                  } else {
                    for (let i = 0; i < uploadedDoc.length; i++) {
                      let obj = {
                        kycDocName: "",
                        uploadedkycDoc: uploadedDoc[i],
                      };
                      this.showDocSection.push(obj);
                    }
                  }
                }

                if (
                  data.editClient[0].nameKYC != null &&
                  data.editClient[0].nameKYC != ""
                ) {
                  let nameKYCArr = [];
                  let phoneKYCArr = [];
                  let emailKYCArr = [];
                  let contactPersonDeptArr = [];
                  let contactPersonDeginationArr = [];
                  if (data.editClient[0].nameKYC) {
                    nameKYCArr = data.editClient[0].nameKYC.split(",");
                  }
                  if (data.editClient[0].kycContact) {
                    phoneKYCArr = data.editClient[0].kycContact.split(",");
                  }
                  if (data.editClient[0].emailKYC) {
                    emailKYCArr = data.editClient[0].emailKYC.split(",");
                  }
                  if (data.editClient[0].contactPersonDept) {
                    contactPersonDeptArr = data.editClient[0].contactPersonDept.split(
                      ","
                    );
                  }
                  if (data.editClient[0].contactPersonDegination) {
                    contactPersonDeginationArr = data.editClient[0].contactPersonDegination.split(
                      ","
                    );
                  }
                  for (let j = 0; j < nameKYCArr.length; j++) {
                    let obj = {
                      name: nameKYCArr[j],
                      email: emailKYCArr[j],
                      phone: phoneKYCArr[j],
                      dept: contactPersonDeptArr[j],
                      deg: contactPersonDeginationArr[j],
                    };
                    this.contactPersonArry.push(obj);
                  }
                }

                Object.keys(data.editClient[0]).map((x) => {
                  this.clientDetail[x] = data.editClient[0][x] || "";

                  if (
                    x == "segment" &&
                    data.editClient[0][x] != null &&
                    data.editClient[0][x] != undefined
                  ) {
                    console.log();
                    array = data.editClient[0][x].split(",");
                  }
                });
                this.clientDetail["segment"] = [];

                this.showSegmentArray.map((x, index) => {
                  let i = array.indexOf(x.value);

                  i >= 0
                    ? (this.clientDetail.segment[index] = true)
                    : (this.clientDetail.segment[index] = false);
                });
              }

              if (data.multiFactoryData.length > 0) {
                this.viewAllFactory = data.multiFactoryData;
              } else {
                this.viewAllFactory = [];
              }
              if (data.editClient.length > 0) {
                if (
                  data.editClient[0].access_branch_json != "" &&
                  data.editClient[0].access_branch_json != null
                ) {
                  this.clientDetail.access_branch_json = JSON.parse(
                    data.editClient[0].access_branch_json
                  );
                  this.branch_items = JSON.parse(data.editClient[0].access_branch_json);

                  if (this.branch_items) {
                    this.branch_items.forEach((item_val) => {
                      if (this.clientDetail.branchName) {
                        this.clientDetail.branchName =
                          this.clientDetail.branchName + "," + item_val.text;
                      } else {
                        this.clientDetail.branchName = item_val.text;
                      }

                      if (this.clientDetail.branchID) {
                        this.clientDetail.branchID =
                          this.clientDetail.branchID + "," + item_val.value;
                      } else {
                        this.clientDetail.branchID = item_val.value;
                      }
                    });
                    //  this.getMultiUserBasedonBranch();
                  }
                } else {
                  this.clientDetail.access_branch_json = [];
                  this.branch_items = [];
                }
                // alert(this.activeUserList.length);

                if (this.activeUserList.length > 0) {
                  if (
                    data.editClient[0].access_user_json != "" &&
                    data.editClient[0].access_user_json != null
                  ) {
                    this.clientDetail.access_user_json = JSON.parse(
                      data.editClient[0].access_user_json
                    );
                    this.user_items = JSON.parse(data.editClient[0].access_user_json);
                    if (this.user_items) {
                      this.user_items.forEach((item_val) => {
                        if (this.clientDetail.userName) {
                          this.clientDetail.userName =
                            this.clientDetail.userName + "," + item_val.text;
                        } else {
                          this.clientDetail.userName = item_val.text;
                        }

                        if (this.clientDetail.userID) {
                          this.clientDetail.userID =
                            this.clientDetail.userID + "," + item_val.value;
                        } else {
                          this.clientDetail.userID = item_val.value;
                        }
                      });
                      console.log("clientDetail=>", this.clientDetail);
                    }
                  } else {
                    this.clientDetail.access_user_json = [];
                    this.user_items = [];
                  }

                  console.log(
                    "this.clientDetail.access_user_json=>",
                    this.clientDetail.access_user_json
                  );
                  console.log(
                    "this.clientDetail.access_branch_json=>",
                    this.clientDetail.access_branch_json
                  );
                  console.log(
                    "this.clientDetail.access_salesPerson_json=>",
                    this.clientDetail.access_salesPerson_json
                  );
                
                }

                
                  // Handle Sales Person data from edit
                  if (
                    data.editClient[0].access_salesPerson_json != "" &&
                    data.editClient[0].access_salesPerson_json != null
                  ) {
                    this.clientDetail.access_salesPerson_json = JSON.parse(
                      data.editClient[0].access_salesPerson_json
                    );
                    console.log("data.editClient[0].access_salesPerson_json=>", data.editClient[0].access_salesPerson_json);
                    this.salesPerson_items = JSON.parse(data.editClient[0].access_salesPerson_json);
                    if (this.salesPerson_items) {
                      this.salesPerson_items.forEach((item_val) => {
                        if (this.clientDetail.salesPersonName) {
                          this.clientDetail.salesPersonName =
                            this.clientDetail.salesPersonName + "," + item_val.text;
                        } else {
                          this.clientDetail.salesPersonName = item_val.text;
                        }

                        if (this.clientDetail.salesPersonID) {
                          this.clientDetail.salesPersonID =
                            this.clientDetail.salesPersonID + "," + item_val.value;
                        } else {
                          this.clientDetail.salesPersonID = item_val.value;
                        }
                      });
                      console.log("clientDetail salesPerson=>", this.clientDetail);
                    }
                  } else {
                    this.clientDetail.access_salesPerson_json = [];
                    this.salesPerson_items = [];
                  }
                // this.SelectMultiUser();
              } else {
                this.clientDetail.access_user_json = [];
                this.clientDetail.access_branch_json = [];
                // this.branch_items = [];
                // this.user_items = [];
              }
              this.stateDetail = data.statelist;
              this.isLoading = false;
              // this.clientDetail.contractId += ",";
              // this.showContract(this.clientDetail.contractId);
            }
          })
          .catch((error) => {});
        //sdsd
      }
    },

    async getContainerLeadGeneralMap(client_id) {
      this.allClientContMonthMapList = [];
      this.allClientContMapList = [];
      if (client_id) {
        return new Promise((resolve) => {
          let payload = {
            itemCode: "getClientContMap",
            client_id: client_id,
          };
          AccountService.getAllContractList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (status == 200 && data.FLAG == 1) {
                this.allClientContMonthMapList = [];
                this.allClientContMapList = [];
                this.allClientContMonthMapList = data.allClientContMonthMapList;
                this.allClientContMapList = data.allClientContMapList;
                if (data.allClientContMapList.length > 0) {
                  this.fk_client_id = data.allClientContMapList[0].fk_client_id;
                  this.fk_lead_id = data.allClientContMapList[0].fk_lead_id;
                  this.fk_enq_id = data.allClientContMapList[0].fk_enq_id;
                  this.enq_no = data.allClientContMapList[0].enq_no;
                }
              }
              return resolve(status == 200 ? true : false);
            })
            .catch((error) => {
              console.log("Catch on getContainerLeadGeneralMap Error: ", error);
            });
        });
      }
    },
    mobileValidation() {
      var mobileFormat = new RegExp("^[0-9]{10}$");

      if (mobileFormat.test(this.clientDetail.phoneKYC)) {
        this.mobileValid = "";
      } else {
        this.mobileValid = "Please Enter Valid Mobile No.";
      }
    },
    showContract(contractid) {
      console.log(contractid, "tyghjtryuhjj");
      let payload = {
        contractId: contractid,
        clientId: this.$sessionsStorage.get("editClientId"),
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/viewContractTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "uyiu");
            if (data.contractArray.length > 0) {
              this.contractTable = data.contractArray;
            }

            this.JqueryFun();
            this.$refs["addPop1"].close();
          }
        })
        .catch((error) => {});
    },

    GSTNErrorValid1() {
      var gstinformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");

      if (gstinformat.test(this.clientDetail.GSTN)) {
        this.GSTNErrorValid = "";
      } else {
        this.GSTNErrorValid = "Please Enter Valid GSTN";
      }
    },
    PANErrorValid1() {
      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

      if (paninformat.test(this.clientDetail.panNO)) {
        this.PANErrorValid = "";
      } else {
        this.PANErrorValid = "Please Enter Valid PAN No.";
      }
    },
    TANErrorValid1() {
      var taninformat = new RegExp("^[A-Z]{4}[0-9]{5}[A-Z]{1}$");

      if (taninformat.test(this.clientDetail.tanNO)) {
        this.TANErrorValid = "";
      } else {
        this.TANErrorValid = "Please Enter Valid TAN No.";
      }
    },
    validateContract() {
      let validate_new = true;
      if (this.contractDetailModal.fromValidity == "") {
        $("#fromValidity").focus();
        this.isFromValidtyError = "Select Validity Date";
        validate_new = false;
      }

      if (this.contractDetailModal.toValidity == "") {
        $("#toValidity").focus();
        this.isToValidtyError = "Select Validity Date";
        validate_new = false;
      }
      if (this.contractDetailModal.contractType == "") {
        $("#contractType").focus();
        this.isContractError = "Select Contract Type";
        validate_new = false;
      }

      if (this.contractDetailModal.monthlyRent == "") {
        $("#monthlyRent").focus();
        this.isMonthlyRentError = "Enter Monthly Month";
        validate_new = false;
      }

      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.allowedKm == ""
      ) {
        $("#allowedKm").focus();
        this.isAllowedKmError = "Enter Allowed Kilometer";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "fuelType" &&
        this.contractDetailModal.milage == ""
      ) {
        $("#milage").focus();
        this.milageError = "Enter your milage";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "fuelType" &&
        this.contractDetailModal.dieselRate == ""
      ) {
        $("#dieselRate").focus();
        this.dieselRateError = "Enter your  diesel rate";
        validate_new = false;
      }

      if (this.contractDetailModal.noOfTrucks == "") {
        $("#noOfTrucks").focus();
        this.noOfTrucksError = "Enter No. of Trucks";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.vehicleType == ""
      ) {
        $("#vehicleType").focus();
        this.vehicleTypeError = "Select Vehicle Type";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.vehicleModal == ""
      ) {
        $("#vehicleModal").focus();
        this.vehicleModalError = "Select vehicle Modal";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.grossWeight == ""
      ) {
        $("#grossWeight").focus();
        this.grossWeightError = "Enter Gross Weight";
        validate_new = false;
      }

      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.overcharges == ""
      ) {
        $("#overcharges").focus();
        this.isOverChargesError = "Enter OverChages";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateClientForm(id) {
      let validate_new = true;

      var gstinformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");

      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");
      var taninformat = new RegExp("^[A-Z]{4}[0-9]{5}[A-Z]{1}$");

      if (this.clientDetail.clientName == "") {
        $("#clientName").focus();
        this.clientError = "Please Enter your name";
        validate_new = false;
      }

      if (this.clientDetail.clientType == "") {
        $("#clientType").focus();
        this.clientTypeError = "Please Select your type";
        validate_new = false;
      }

      if (this.clientDetail.companyType == "") {
        $("#companyType").focus();
        this.companyTypeError = "Please select company";
        validate_new = false;
      }
      if (this.clientDetail.permitted != "GSTUnregistered") {
        if (gstinformat.test(this.clientDetail.GSTN)) {
          this.GSTNErrorValid = "";
        } else {
          validate_new = false;
          $("#GSTN").focus();

          this.GSTNErrorValid = "Please Enter Valid GSTN";
        }

        if (this.clientDetail.GSTN == "") {
          $("#GSTN").focus();
          this.GSTNError = "Please Enter GSTN";
          validate_new = false;
        }
      }
      if (paninformat.test(this.clientDetail.panNO)) {
        this.PANErrorValid = "";
      } else {
        validate_new = false;
        $("#panNO").focus();

        this.PANErrorValid = "Please Enter Valid PAN No.";
      }

      if (this.clientDetail.panNO == "") {
        $("#panNO").focus();
        this.panNOError = "Please Enter your pan no.";
        validate_new = false;
      }

      // if (
      //   this.clientDetail.isContract == "Yes" &&
      //   this.clientDetail.hireContract == ""
      // ) {
      //   $("#isContract2").focus();
      //   this.hireContractError = "Select a particular Contract";
      //   validate_new = false;
      // }

      // if (
      //   this.clientDetail.contractId == "" &&
      //   this.clientDetail.isContract == "Yes" &&
      //   this.clientDetail.hireContract == "hireContract"
      // ) {
      //   $("#isContract2").focus();
      //   this.isContractError1 = "Add atleast one contract";
      //   validate_new = false;
      // }

      if (this.clientDetail.state == "") {
        $("#state").focus();
        this.stateError = "Please Enter your state name";
        validate_new = false;
      }

      if (taninformat.test(this.clientDetail.tanNO)) {
        this.TANErrorValid = "";
      } else {
        validate_new = false;
        $("#tanNO").focus();

        this.TANErrorValid = "Please Enter Valid TAN No.";
      }
      if (this.clientDetail.tanNO == "") {
        $("#tanNO").focus();
        this.tanNOError = "Please Enter your tan No.";
        validate_new = false;
      }

      if (this.clientDetail.corporateAddress == "") {
        $("#corporateAddress").focus();
        this.corporateAddressError = "Please Enter your address";
        validate_new = false;
      }

      if (this.clientDetail.email == "") {
        $("#email").focus();
        this.emailError = "Please Enter Email address";
        validate_new = false;
      }

      if (this.clientDetail.phoneKYC == "") {
        $("#phoneKYC").focus();
        this.phoneKYCError = "Enter your number";
        validate_new = false;
      }

      // if (this.clientDetail.isKYC == "Yes" && this.clientDetail.panCard == "") {
      //   this.panCardError = "Upload your pancard document";
      //   validate_new = false;
      // }

      // if (
      //   this.clientDetail.isKYC == "Yes" &&
      //   this.clientDetail.aadharCard == ""
      // ) {
      //   this.aadharError = "Upload Your GST document";
      //   validate_new = false;
      // }

      if (id == "") {
        if (this.factoryModal.factoryAddress1 == "") {
          $("#factoryAddress1").focus();

          this.factoryAddress1Error = "Enter Factory Address";
          validate_new = false;
        }
        // if (this.factoryModal.location == "") {
        //   $("#location").focus();
        //   this.locationError = "Enter Factory Location";
        //   validate_new = false;
        // }
        if (this.factoryModal.factoryTitle == "") {
          $("#factoryTitle").focus();
          this.factoryTitleError = "Enter Factory Title";
          validate_new = false;
        }
      }
      // if (id != "") {
      //   if (this.viewAllFactory.length <= 0) {
      //     this.multiFactError = "Enter atleast one Factory Details";
      //     validate_new = false;
      //   } else {
      //     this.multiFactError = "";
      //   }
      //   // if (this.clientDetail.detentionPeriod == "") {
      //   //   $("#detentionPeriod").focus();
      //   //   this.detentionPeriodError = "Enter your detention";
      //   //   validate_new = false;
      //   // }
      //   if (this.clientDetail.permitted == "") {
      //     $("#permitted1").focus();
      //     this.permittedError = "Please Select your Permit";
      //     validate_new = false;
      //   }
      //   if (this.clientDetail.isContract == "") {
      //     $("#isContract2").focus();
      //     this.isContractError = "Please select your contract";
      //     validate_new = false;
      //   }
      // }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addClient(id, AddType) {
      this.clientDetail["kycDocSection"] = this.showDocSection;
      this.clientDetail["contactPersonArry"] = this.contactPersonArry;
      this.validateClientForm(id);

      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.clientDetail.email)) {
        this.errorEmailFormat = "";
      } else {
        this.errorEmailFormat = "Enter Valid Email";
        window.scroll(0, 20);
        return false;
      }

      // var mobileFormat = new RegExp("^[0-9]{10}$");

      // if (mobileFormat.test(this.clientDetail.phoneKYC)) {
      //   this.mobileValid = "";
      // } else {
      //   window.scroll(0, 20);

      //   this.mobileValid = "Please Enter Valid Mobile No.";
      //   return false;
      // }
      // if (this.clientDetail.isContract == "No") {
      //   this.clientDetail.hireContract = "";
      // }
      if (this.user_items) {
        this.clientDetail.userID = "";
        this.clientDetail.userName = "";
        let access_user_jsonArr = [];
        this.user_items.forEach((item_val) => {
          let userObj = {};
          if (this.clientDetail.userName) {
            this.clientDetail.userName = this.clientDetail.userName + "," + item_val.text;
          } else {
            this.clientDetail.userName = item_val.text;
          }

          if (this.clientDetail.userID) {
            this.clientDetail.userID = this.clientDetail.userID + "," + item_val.value;
          } else {
            this.clientDetail.userID = item_val.value;
          }
          userObj = { text: item_val.text, value: item_val.value };
          access_user_jsonArr.push(userObj);
        });
        if (access_user_jsonArr.length > 0) {
          this.clientDetail.access_user_json = access_user_jsonArr;
        }
        console.log("clientDetail=>", this.clientDetail);
      }

      // Process Sales Person data
      if (this.salesPerson_items && this.salesPerson_items.length > 0) {
        this.clientDetail.salesPersonID = "";
        this.clientDetail.salesPersonName = "";
        let access_salesPerson_jsonArr = [];
        this.salesPerson_items.forEach((item_val) => {
          let salesPersonObj = {};
          if (this.clientDetail.salesPersonName) {
            this.clientDetail.salesPersonName = this.clientDetail.salesPersonName + "," + item_val.text;
          } else {
            this.clientDetail.salesPersonName = item_val.text;
          }

          if (this.clientDetail.salesPersonID) {
            this.clientDetail.salesPersonID = this.clientDetail.salesPersonID + "," + item_val.value;
          } else {
            this.clientDetail.salesPersonID = item_val.value;
          }
          salesPersonObj = { text: item_val.text, value: item_val.value };
          access_salesPerson_jsonArr.push(salesPersonObj);
        });
        if (access_salesPerson_jsonArr.length > 0) {
          this.clientDetail.access_salesPerson_json = access_salesPerson_jsonArr;
        }
        console.log("clientDetail salesPerson=>", this.clientDetail);
      } else {
        this.clientDetail.salesPersonID = "";
        this.clientDetail.salesPersonName = "";
        this.clientDetail.access_salesPerson_json = [];
      }

      if (this.branch_items) {
        this.clientDetail.branchID = "";
        this.clientDetail.branchName = "";
        let access_branch_jsonArr = [];
        this.branch_items.forEach((item_val) => {
          let clientObj = {};
          if (this.clientDetail.branchName) {
            this.clientDetail.branchName =
              this.clientDetail.branchName + "," + item_val.text;
          } else {
            this.clientDetail.branchName = item_val.text;
          }

          if (this.clientDetail.branchID) {
            this.clientDetail.branchID =
              this.clientDetail.branchID + "," + item_val.value;
          } else {
            this.clientDetail.branchID = item_val.value;
          }
          clientObj = { text: item_val.text, value: item_val.value };
          access_branch_jsonArr.push(clientObj);
        });
        if (access_branch_jsonArr.length > 0) {
          this.clientDetail.access_branch_json = access_branch_jsonArr;
        }
        console.log("clientDetail=>", this.clientDetail);
      }
      if (this.validate != false) {
        this.isLoading = true;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let newVal = [];
        if (id != "") {
          this.showSegmentArray.map((x, index) => {
            if (this.clientDetail.segment[index] == true) {
              newVal.push(x.value);
            }
          });

          this.clientDetail.segment = newVal;
        }
        let new_data = {
          clientDetail: this.clientDetail,
          factoryModal: this.factoryModal,
          AddType: AddType,
        };
        console.log(new_data);
        if (id == "") {
          new_data["onlyExecMain"] = "";
        } else {
          new_data["onlyExecMain"] = "csfds";
        }

        console.log(new_data);
        // return false;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addClient.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              console.log(result.data);
              console.log("Happy Singh=>", result.data);
              // alert(result.data.clientId)
              if (
                result.data.clientId != "" &&
                result.data.clientId != undefined &&
                result.data.clientId != null
              ) {
                // alert('Hi');
                this.clientDetail.clientId = result.data.clientId;
              }
              if (this.$sessionsStorage.get("editClientId") != "") {
                this.$sessionsStorage.set("editClientId", result.data.clientId);
                this.clientDetail.clientId = result.data.clientId;
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.getTypeSize(this.$sessionsStorage.get("editClientId"));
              if (id != "") {
                // this.alert.content = "Action Successful";
                // this.$refs["addPopSave"].open();
              }
              this.alert.content = data.msg;
              this.$refs["addPopSave"].open();
            }
          })
          .catch((error) => {});
      }
    },
    openLocationDialog() {
      this.$refs["dialogLocation"].open();
    },
    openContractDialog() {
      this.$refs["dialog2"].open();
    },
    fetchState() {
      let vehicle_drive = {
        state: "state",
      };
      if (this.count >= 2) {
        vehicle_drive["stateId"] = this.clientDetail.state;
      } else {
        vehicle_drive["stateId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchStateToClient.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.stateDetail = data.statelist;

            if (data.gstCode != "") {
              this.clientDetail.GSTN = data.gstCode;
            }
            this.count++;
          }
        })
        .catch((error) => {});
    },
    addContract() {
      this.validateContract();
      if (this.validate != false) {
        if (this.clientDetail.clientId != "") {
          this.contractDetailModal["clientId"] = this.clientDetail.clientId;
        } else {
          this.contractDetailModal["clientId"] = "";
        }
        this.$refs["dialog2"].close();
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TPTContract/addContractDetail.php`,
          data: JSON.stringify(this.contractDetailModal),

          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.clientDetail.contractId += data.Id + ",";

              this.$refs["addPop1"].open();
            }
          })
          .catch((error) => {});
      }
    },
    validateUser() {},
    getSegmentData() {
      this.showSegmentArray = [
        {
          value: "OceanImport",
          show: "Ocean Import",
          flex: "15",
        },
        {
          value: "OceanExport",
          show: "Ocean Export",
          flex: "15",
        },
        {
          value: "AirImport",
          show: "Air Import",
          flex: "15",
        },

        {
          value: "AirExport",
          show: "Air Export",
          flex: "15",
        },
        {
          value: "Trucking",
          show: "Trucking",
          flex: "15",
        },
        {
          value: "CustomClearance",
          show: "Custom Clearance",
          flex: "20",
        },
      ];

      this.showDocumentArray = [
        {
          value: "panCard",
          show: "Pan Card",
          flex: "15",
          url: `Client/Pancard/`,
        },
        {
          value: "aadharCard",
          show: "GST Certificate",
          flex: "15",
          url: `Client/Aadhar/`,
        },
        {
          value: "voterCard",
          show: "Address Proof",
          flex: "15",
          url: `Client/VoterCard/`,
        },
        {
          value: "uploadKYC",
          show: "Other Document",
          flex: "15",
          url: `Client/Other/`,
        },
      ];
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 2%;
}
.mrgtop-3per {
  margin-top: 4%;
}
.mrgtop-5px {
  margin-top: 5px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}

h3 {
  margin: 0px !important;
}

.md-button-color {
  background-color: #607d8d !important;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 99;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 100%;
  height: 100%;
}
.back {
  margin-top: 8px;
  height: 1px;
}
.hr-s {
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// addClient.vue?7cb57160